import fscreen from 'fscreen';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Actions } from '~/actions';
import { ofType } from '@mode/legacy/util-domain';
import { AppStore } from '~/types/main.types';

import { WindowActions } from '../actions/window.actions';

export class FullscreenService {
  static $inject = ['RxStoreService', 'actions$'];

  constructor(
    private store: AppStore,
    private actions$: Observable<Actions>
  ) {
    fscreen.addEventListener(
      'fullscreenchange',
      () => {
        if (fscreen.fullscreenElement != null) {
          this.store.dispatch(new WindowActions.EnterFullscreenSuccess());
        } else {
          this.store.dispatch(new WindowActions.ExitFullscreen());
        }
      },
      false
    );

    fscreen.addEventListener(
      'fullscreenerror',
      () => {
        this.store.dispatch(new WindowActions.EnterFullscreenFailure(new Error('unable to fullscreen')));
      },
      false
    );

    this.actions$
      .pipe(ofType(WindowActions.Type.EnterFullscreen))
      .subscribe((action) => fscreen.requestFullscreen(action.element));

    this.actions$
      .pipe(
        ofType(WindowActions.Type.ExitFullscreen),
        filter(() => fscreen.fullscreenElement != null) // Verify full screen mode before exiting
      )
      .subscribe(() => fscreen.exitFullscreen());
  }

  get isFullscreen$(): Observable<boolean> {
    return this.store.select('transient', 'window', 'isFullscreen');
  }
}
